import { VehicleInformationType } from '@thesavingsgroup/enums/VehicleInformationType';
import { UserVehicleInformationDto } from '@thesavingsgroup/user-vehicle-information/UserVehicleInformationDto';
import { get } from 'lodash';

export const getVehicleInformationByType = (
  information: UserVehicleInformationDto[],
  type: VehicleInformationType,
): UserVehicleInformationDto | undefined => {
  if (!information) {
    return undefined;
  }

  return information.find((entry) => get(entry, 'type') === type);
};
